jQuery(function ($) {

  var $slider = $('.slider-wrapper .product__media-list__container--large-default');

function updateActiveColorVisibility() {
  if ($slider.hasClass('slick-initialized')) {
    // Loop through each slide
    $slider.find('.slick-slide').each(function () {
      const $slide = $(this);
      if ($slide.find('.active-color').length > 0) {
        $slide.show();
      } else {
        $slide.hide();
      }
    });

    // Refresh slick to recalculate visible slides and dots
    $slider.slick('refresh');
  }
}

function initMediaSlider() {
  if (window.innerWidth <= 768 && $slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      dots: true,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16.0001" y="7.24994" width="14" height="1.99996" transform="rotate(-180 16.0001 7.24994)" fill="#111111"></rect><path d="M5.63647 12.2499L0.363745 6.24986L1.72738 4.74986L7.00011 10.7499L5.63647 12.2499Z" fill="#111111"></path><path d="M7.00016 1.74985L1.72742 7.74999L0.363787 6.25002L5.63652 0.249817L7.00016 1.74985Z" fill="#111111"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.00012207" y="5.32214" width="14" height="2" fill="#111111"></rect><path d="M10.3635 0.322144L15.6363 6.32214L14.2726 7.82214L8.99989 1.82214L10.3635 0.322144Z" fill="#111111"></path><path d="M8.99984 10.8222L14.2726 4.82217L15.6362 6.32211L10.3635 12.3222L8.99984 10.8222Z" fill="#111111"></path></svg></button>'
    });

    // Hide non-active-color slides initially
    setTimeout(() => {
      updateActiveColorVisibility();
    }, 100);
  }
}

// Initialize on page load
initMediaSlider();

// Update visibility of slides on color swatch click
$(document).on("click", ".color-swatch", function () {
  // Optional: update .active-color dynamically here if needed

  updateActiveColorVisibility();
});


});


    jQuery('.product-modal-slick-slider').slick({
      slidesToShow: 1,
      arrows: true,
      dots: false,
      infinite: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev custom-slick-arrow"><svg width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#fff" opacity="0.85"/><path d="M18.5 22l-5-6 5-6" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next custom-slick-arrow"><svg width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#fff" opacity="0.85"/><path d="M13.5 10l5 6-5 6" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>'
    });



// jQuery(function ($) {

//   function showSliderByColor(colorValue) {
//     if (!colorValue) return;

//     const sliderKey = `__${colorValue}`;

//     // Hide all sliders
//     $('.product-slider-wrapper').hide();

//     // Show the matched slider
//     const $targetSliderWrapper = $(`.product-slider-wrapper[data-slider-alt="${sliderKey}"]`);
//     $targetSliderWrapper.show();

//     // Go to first slide
//     const $slider = $targetSliderWrapper.find('.product-slider');
//     if ($slider.hasClass('slick-initialized')) {
//       $slider.slick('slickGoTo', 0);
//     }
//   }

//   // On swatch click
//   $(document).on('click', '.color-swatch', function () {
//     const color = $(this).data('variabt-color');
//     showSliderByColor(color);
//   });

//   // ✅ On page load
//   const $checkedInput = $('input[name="Color"]:checked');
//   if ($checkedInput.length) {
//     const id = $checkedInput.attr('id');
//     const $matchedLabel = $(`label[for="${id}"]`);
//     const color = $matchedLabel.data('variabt-color');
//     showSliderByColor(color);
//   }

//   // Initialize all slick sliders after DOM is ready
  
//  $('.product-slider').slick({
//       dots: true,
//       arrows: true,
//       infinite: false,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       adaptiveHeight: true,
//       prevArrow: '<button type="button" class="slick-prev"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16.0001" y="7.24994" width="14" height="1.99996" transform="rotate(-180 16.0001 7.24994)" fill="#111111"></rect><path d="M5.63647 12.2499L0.363745 6.24986L1.72738 4.74986L7.00011 10.7499L5.63647 12.2499Z" fill="#111111"></path><path d="M7.00016 1.74985L1.72742 7.74999L0.363787 6.25002L5.63652 0.249817L7.00016 1.74985Z" fill="#111111"></path></svg></button>',
//       nextArrow: '<button type="button" class="slick-next"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.00012207" y="5.32214" width="14" height="2" fill="#111111"></rect><path d="M10.3635 0.322144L15.6363 6.32214L14.2726 7.82214L8.99989 1.82214L10.3635 0.322144Z" fill="#111111"></path><path d="M8.99984 10.8222L14.2726 4.82217L15.6362 6.32211L10.3635 12.3222L8.99984 10.8222Z" fill="#111111"></path></svg></button>'
//     });
  
// });

// jQuery(function ($) {
//   let $popupSlider;

//   function openPopup(images, startIndex = 0) {
//     const $popup = $('#custom-popup');
//     const $sliderWrapper = $popup.find('.popup-slider-wrapper');

//     // Destroy old Slick instance if exists
//     if ($sliderWrapper.hasClass('slick-initialized')) {
//       $sliderWrapper.slick('unslick');
//     }

//     // Reset
//     $sliderWrapper.empty();

//     // Add images
//     images.forEach(src => {
//       $sliderWrapper.append(`
//         <div class="popup-slide">
//           <img src="${src}"  />
//         </div>
//       `);
//     });

//     $popup.show();

//     // Initialize Slick
//     $sliderWrapper.slick({
//   slidesToShow: 1,
//   arrows: true,
//   dots: false,
//   infinite: false,
//   initialSlide: startIndex,
//   prevArrow: '<button type="button" class="slick-prev custom-slick-arrow"><svg width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#fff" opacity="0.85"/><path d="M18.5 22l-5-6 5-6" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>',
//   nextArrow: '<button type="button" class="slick-next custom-slick-arrow"><svg width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#fff" opacity="0.85"/><path d="M13.5 10l5 6-5 6" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>',
//   adaptiveHeight: true
// });


//     $popupSlider = $sliderWrapper;
//     if ($popupSlider.hasClass('slick-initialized')) {
//       $popupSlider.slick('slickGoTo', startIndex);
//     }
//     $popupSlider.slick('slickGoTo', startIndex);
//     $sliderWrapper.slick('slickGoTo', startIndex);
//   }

//   function closePopup() {
//     $('#custom-popup').hide();
//     if ($popupSlider && $popupSlider.hasClass('slick-initialized')) {
//       $popupSlider.slick('unslick');
//     }
//   }

//   // Open on slide click
//   $(document).on('click', '.product-slide img', function () {
//     const $currentWrapper = $(this).closest('.product-slider-wrapper');
//     const imageElements = $currentWrapper.find('.product-slide img');

//     const imageSrcs = imageElements.map(function () {
//       return $(this).attr('src');
//     }).get();

//     const clickedSrc = $(this).attr('src');
//     const startIndex = imageSrcs.indexOf(clickedSrc);
//     openPopup(imageSrcs, startIndex);
//   });

//   // Popup overlay/close
//   $(document).on('click', '.popup-close, .popup-overlay', closePopup);

//   // Keyboard navigation
//   $(document).on('keydown', function (e) {
//     if (!$('#custom-popup').is(':visible')) return;

//     if (e.key === 'Escape') closePopup();
//   });
// });

jQuery(function ($) {

  function showSliderByColor(colorValue) {
    if (!colorValue) return;

    const sliderKey = `__${colorValue}`;

    // Hide all sliders
    $('.product-slider-wrapper').hide();

    // Show the matched slider
    const $targetSliderWrapper = $(`.product-slider-wrapper[data-slider-alt="${sliderKey}"]`);
    $targetSliderWrapper.show();

    // Go to first slide if initialized
    const $slider = $targetSliderWrapper.find('.product-slider');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('slickGoTo', 0);
    }
  }

  // Swatch click handler
  $(document).on('click', '.color-swatch', function () {
    const color = $(this).data('variabt-color');
    showSliderByColor(color);
  });

  // On load – show default selected slider
  const $checkedInput = $('input[name="Color"]:checked');
  if ($checkedInput.length) {
    const id = $checkedInput.attr('id');
    const $matchedLabel = $(`label[for="${id}"]`);
    const color = $matchedLabel.data('variabt-color');
    showSliderByColor(color);
  }

  // Function to initialize or destroy slick based on screen width
  function handleResponsiveSlider() {
    $('.product-slider').each(function () {
      const $slider = $(this);
      const isMobile = window.innerWidth <= 767;

      if (isMobile && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: true,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slick-prev"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16.0001" y="7.24994" width="14" height="1.99996" transform="rotate(-180 16.0001 7.24994)" fill="#111111"></rect><path d="M5.63647 12.2499L0.363745 6.24986L1.72738 4.74986L7.00011 10.7499L5.63647 12.2499Z" fill="#111111"></path><path d="M7.00016 1.74985L1.72742 7.74999L0.363787 6.25002L5.63652 0.249817L7.00016 1.74985Z" fill="#111111"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.00012207" y="5.32214" width="14" height="2" fill="#111111"></rect><path d="M10.3635 0.322144L15.6363 6.32214L14.2726 7.82214L8.99989 1.82214L10.3635 0.322144Z" fill="#111111"></path><path d="M8.99984 10.8222L14.2726 4.82217L15.6362 6.32211L10.3635 12.3222L8.99984 10.8222Z" fill="#111111"></path></svg></button>'
        });
      } else if (!isMobile && $slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    });
  }

  // Initial check
  handleResponsiveSlider();

  // On resize
  $(window).on('resize', function () {
    handleResponsiveSlider();
  });

});


jQuery(function ($) {
  let $popupSlider;

  function openPopup(images, startIndex = 0) {
    const $popup = $('#custom-popup');
    const $sliderWrapper = $popup.find('.popup-slider-wrapper');

    if ($sliderWrapper.hasClass('slick-initialized')) {
      $sliderWrapper.slick('unslick');
    }

    $sliderWrapper.empty();

    images.forEach(src => {
      $sliderWrapper.append(`
        <div class="popup-slide">
          <img src="${src}" />
        </div>
      `);
    });

    $popup.show();

    $sliderWrapper.slick({
      slidesToShow: 1,
      arrows: true,
      dots: false,
      infinite: false,
      initialSlide: startIndex,
      prevArrow: '<button type="button" class="slick-prev custom-slick-arrow"><svg width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#fff" opacity="0.85"/><path d="M18.5 22l-5-6 5-6" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next custom-slick-arrow"><svg width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#fff" opacity="0.85"/><path d="M13.5 10l5 6-5 6" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg></button>',
      adaptiveHeight: true
    });

    $popupSlider = $sliderWrapper;
  }

  function closePopup() {
    $('#custom-popup').hide();
    if ($popupSlider && $popupSlider.hasClass('slick-initialized')) {
      $popupSlider.slick('unslick');
    }
  }

  // ✅ Main click handler for product-slide image
  $(document).on('click', '.product-slide img', function () {
    const isMobile = window.innerWidth <= 767;
    const $clickedImg = $(this);

    const $sliderWrapper = $clickedImg.closest('.product-slider');

    let imageSrcs = [];
    let startIndex = 0;

    if (isMobile && $sliderWrapper.hasClass('slick-initialized')) {
      // ✅ On mobile (Slick active)
      const $allSlides = $sliderWrapper.find('.slick-slide img');
      imageSrcs = $allSlides.map(function () {
        return $(this).attr('src');
      }).get();

      const clickedSrc = $clickedImg.attr('src');
      startIndex = imageSrcs.indexOf(clickedSrc);

    } else {
      // ✅ On desktop (Not Slick)
      const $staticWrapper = $clickedImg.closest('.product-slider');
      const $images = $staticWrapper.find('.product-slide img');

      imageSrcs = $images.map(function () {
        return $(this).attr('src');
      }).get();

      const clickedSrc = $clickedImg.attr('src');
      startIndex = imageSrcs.indexOf(clickedSrc);
    }

    openPopup(imageSrcs, startIndex);
  });

  // ✅ Close popup
  $(document).on('click', '.popup-close, .popup-overlay', closePopup);
  $(document).on('keydown', function (e) {
    if ($('#custom-popup').is(':visible') && e.key === 'Escape') {
      closePopup();
    }
  });
});




class SlickElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlick();
  }

  initSlick() {
    const $slider = $(this).find('.slick-slider');
    const slickOptions = $(this).data('slick');

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    let slickOption = {
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="16.0001" y="7.24994" width="14" height="1.99996" transform="rotate(-180 16.0001 7.24994)" fill="#111111"></rect><path d="M5.63647 12.2499L0.363745 6.24986L1.72738 4.74986L7.00011 10.7499L5.63647 12.2499Z" fill="#111111"></path><path d="M7.00016 1.74985L1.72742 7.74999L0.363787 6.25002L5.63652 0.249817L7.00016 1.74985Z" fill="#111111"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.00012207" y="5.32214" width="14" height="2" fill="#111111"></rect><path d="M10.3635 0.322144L15.6363 6.32214L14.2726 7.82214L8.99989 1.82214L10.3635 0.322144Z" fill="#111111"></path><path d="M8.99984 10.8222L14.2726 4.82217L15.6362 6.32211L10.3635 12.3222L8.99984 10.8222Z" fill="#111111"></path></svg></button>',
      ...slickOptions
    };

    console.log(slickOption)

    $slider.slick(slickOption);

  }
}

customElements.define('slick-element', SlickElement);


